<template>
  <div>
    <table class="table table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th>Nome</th>
          <th>CBO</th>
          <th>Conselho</th>
          <th>Número Conselho</th>
          <th>Situação</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="m in medicos" :key="m._id">
          <td>{{ m.nome }}</td>
          <td v-if="m.cbo">{{ m.cbo.codigo }} - {{ m.cbo.valor }}</td>
          <td v-else>Não informado</td>
          <td>{{ m.conselho }} / {{ m.ufConselho }}</td>
          <td>{{ m.numeroConselho }}</td>
          <td>{{ m.ativo ? 'Ativo' : 'Cancelado' }}</td>
          <td>
            <RouterLink
              v-tooltip="'Editar'"
              data-test-id="link-auto-1"
              :to="'/medico/cadastro/' + m._id"
              role="button"
              class="btn btn-xs btn-link"
            >
              <span class="fa fa-edit" />
            </RouterLink>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'MedicoTabela',
  props: {
    medicos: {
      type: Array,
      required: true,
    },
  },
}
</script>
